module.exports = __webpack_public_path__ + "static/Mosel1-scaled-2291ba54b9f16b3ee1840e0c02472f20.jpeg";